import { Owner } from '@/reports/PersonBasedReport';
import { commonTypes, peopleTypes, serializedTypes } from '@/reports/types';
import { ReportSectionData } from '@/utils/helperTypes';

type DataType = Exclude<
  ReportSectionData,
  | serializedTypes.SerializedPerson
  | peopleTypes.UCC
  | peopleTypes.DEA
  | peopleTypes.Sporting
  | peopleTypes.Business
  | peopleTypes.FAA
  | peopleTypes.Professional
  | peopleTypes.Weapon
>;
const filterHighConfidence = (
  data: DataType[] | commonTypes.Emails,
  higherConfidenceThreshold: number,
  allowedDerivedEmails?: boolean,
  category?: string
) =>
  data.filter(
    (datum) =>
      (allowedDerivedEmails &&
        category === 'email' &&
        datum.meta?.is_derived) ||
      (datum.meta?.confidence &&
        datum.meta?.confidence >= higherConfidenceThreshold)
  );

const traverseOwner = (
  owner: Owner,
  filter: (data: DataType[], category?: string) => DataType[]
) => {
  return {
    ...owner,
    emails: filter(owner.emails, 'email'),
    phones: filter(owner.phones),
    addresses: filter(owner.addresses),
    images: filter(owner.images),
    profiles: filter(owner.profiles),
  };
};

export const higherConfidenceFilter = (
  owner: Owner,
  higherConfidenceThreshold: number,
  allowedDerivedEmails?: boolean
) => {
  const filter = (data: DataType[], category?: string) =>
    filterHighConfidence(
      data,
      higherConfidenceThreshold,
      allowedDerivedEmails,
      category
    );
  return traverseOwner(owner, filter) as Owner;
};
